/**
     * @desc 查询订单状态
带合约操作的接口，非盲盒页面，操作类型:listing,cancellisting,buy,cancelbid,acceptbid
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/getOrderStatus', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/getOrderStatus', params);
}
